import { useState } from 'react';
import axios from 'axios';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import './App.css';
import Nav from './Nav';
import Footer from './Footer';
import homebg from './Images/homebg.jpg'

var data1 = [];

function App() {

  const [data, setData] = useState(data1);

  const getDataFromAPI = () =>{
    
    const options = {
      method: 'GET',
      url: 'https://the-vegan-recipes-db.p.rapidapi.com/',
      headers: {
        'x-rapidapi-key': '5c9c1070demsh02c080148828a4ap1bdc46jsna4f9994d25bf',
        'x-rapidapi-host': 'the-vegan-recipes-db.p.rapidapi.com'
      }
    };
    

    axios.request(options).then((opt) => {
       console.log(opt);
      console.log(opt.data);
      console.log(opt.data[0].id);
      console.log(opt.data[0].title);
      console.log(opt.data[0].difficulty);
      console.log(opt.data[0].image);
      
      
      setData(opt.data);
    }).catch((error)=>{
      console.log(error);
    })
   
  }
  
  
  return (
   
    
    <div className="container-fluid g-0">
     <div className='row'>
     <Nav/>
     </div>
    
    
  <div className='container-fluid'>
  <div className='row justify-content-center'>
  <img src={homebg} class="img-fluid home"/>
  <div>
  <button type='button' onClick={getDataFromAPI} className='btn btn-warning fs-3 p-3 mx-auto rounded-pill mt-5'>Show Food Data</button>
  </div>
  {data.map((dt, key)=>{
    return(

      
      <div key={key} className='col-12 col-md-4 col-lg-3 m-2 m-lg-4 p-lg-3  bg-warning'>
        <img src={dt.image} className ="img-fluid mt-2  " alt=''/>
        <h1 className='fs-4 text-center'>{dt.title}</h1>
        <h1 className='fs-4 text-center'>{dt.difficulty}</h1>
        </div>
       
       
    );
  })

  }


     
    </div>
    </div>
    <Footer/>
    </div>


  );
}


export default App;
